import fraudMonitorReducer from './fraudMonitorReducer';
import infoMonitorReducer from './infoMonitorReducer';
import partnerLevelAlertsReducer from './partnerLevelAlertsReducer';

export default {
  fraudMonitor: fraudMonitorReducer,
  infoMonitor: infoMonitorReducer,
  partnerLevelAlerts: partnerLevelAlertsReducer
};
